import { render } from "./CategoryPhotos.vue?vue&type=template&id=c1e9f850&scoped=true"
import script from "./CategoryPhotos.vue?vue&type=script&lang=js"
export * from "./CategoryPhotos.vue?vue&type=script&lang=js"

import "./CategoryPhotos.vue?vue&type=style&index=0&id=c1e9f850&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e9f850"]])

export default __exports__